<ng-content></ng-content>
<i nz-icon nzType="close" *ngIf="nzMode==='closeable'" tabindex="-1" (click)="closeTag($event)"></i>
